import { CanDeactivateFn } from '@angular/router';
import { EditorComponent } from '../../features/editor/editor';

export const unsavedChangesGuard: CanDeactivateFn<EditorComponent> = (
	component,
	currentRoute,
	_currentState,
	nextState,
) => {
	// Don't block navigation within the same editor (e.g. project → scene → image)
	const currentId = currentRoute.paramMap.get('id');
	const nextId = nextState?.root.firstChild?.paramMap.get('id');
	if (currentId && currentId === nextId) return true;

	if (component.hasUnsavedChanges()) {
		return confirm('You have unsaved changes. Leave anyway?');
	}
	return true;
};
